
import Vue from 'vue';
import { ClientConstants } from './../client.constants';
export default Vue.extend({
    data: () => {
        return {
            fidelityUrl: ClientConstants.FIDELITY_URL
        }
    },
});
